import React, { Component } from 'react';
import {connect} from 'react-redux';


// const Ticketrequest = props => {
  class Ticketrequest extends Component {

render(){
  return (

        <div style={{'box-shadow': '0 0 7px rgba(0,0,0,0.5)', 'color':'#980837', 'font-size':'1.2em', 'margin-bottom':'20px', 'padding':'2px', 'text-align':'center'}}>

          {this.props.auth ?
              '<a href="http://ocnit.tula.ru/api/tickets"> Заявки </a>'
              :
              'Доступ к разделу ограничен. Необходима авторизация.'
          }

        </div>
  )

}

}

export default connect(
  state => ({
    auth:state.auth
  })
)(Ticketrequest)
